
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    pagePage: {
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0,
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        backgroundColor: '#f4eeee',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    header: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '7px 33px',
        backgroundColor: '#f4eeee',
        boxShadow: '0 2px 10px rgba(0,0,0,0.02)',
        borderBottom: '1px solid #eee',
    },
    logo: {
        height: '60px',
    },
    nav: {
        display: 'flex',
        gap: '40px',
        flexGrow: 1,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    navLink: {
        textDecoration: 'none',
        color: '#444',
        fontWeight: 500,
        fontSize: '18px',
        transition: 'color 0.3s',
        '&:hover': {
            color: '#ff6468',
        },
    },
    upgradeBtn: {
        background: '#ff6468 !important',
        color: '#fff !important',
        padding: '8px 45px !important',
        borderRadius: '25px !important',
        fontWeight: 'bold !important',
        fontSize: '16px !important',
        textTransform: 'none !important',
        marginLeft: 'auto',
        '&:hover': {
            background: '#e05559 !important',
        },
    },
    contentArea: {
        flex: 1,
        padding: '60px 40px 100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'transparent',
    },
    title: {
        fontSize: '32px !important',
        fontWeight: 'bold !important',
        color: '#000',
        marginBottom: '10px !important',
        textAlign: 'center',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
    },
    subtitle: {
        fontSize: '14px !important',
        color: '#666',
        marginBottom: '60px !important',
        textAlign: 'center',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
    },
    cardsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '20px',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            flexWrap: 'wrap',
        },
    },
    card: {
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '20px !important',
        padding: '40px 25px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        width: '22%',
        minHeight: '600px',
        transition: 'all 0.3s ease',
        position: 'relative',
        '&:hover': {
            transform: 'translateY(-10px)',
            boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.1)',
            borderColor: '#ff6468',
        },
        [theme.breakpoints.down('md')]: {
            width: '45%',
            minHeight: '600px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%',
            minHeight: 'auto',
        },
    },
    recommendedCard: {
        borderColor: '#ff6468',
        borderWidth: '2px',
    },
    badge: {
        position: 'absolute',
        top: '15px',
        right: '25px',
        backgroundColor: '#ff6468',
        color: '#fff',
        padding: '2px 10px',
        borderRadius: '10px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    planTitleWrapper: {
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: '10px',
        width: '100%',
    },
    planTitle: {
        fontSize: '24px !important',
        fontWeight: 'bold !important',
        color: '#000',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
    },
    priceWrapper: {
        height: '60px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        marginBottom: '30px',
    },
    divider: {
        width: '100%',
        height: '1px',
        backgroundColor: '#eee',
        marginBottom: '7px',
    },
    price: {
        fontSize: '36px !important',
        fontWeight: 'bold !important',
        color: '#000',
    },
    period: {
        fontSize: '14px !important',
        color: '#888',
        marginBottom: '8px',
        marginLeft: '4px',
    },
    featureTitleWrapper: {
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    featureTitle: {
        fontSize: '18px !important',
        fontWeight: 'bold !important',
        color: '#000',
        lineHeight: 1.2,
    },
    descriptionWrapper: {
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginBottom: '10px',
    },
    description: {
        fontSize: '14px !important',
        color: '#666',
        textAlign: 'center',
        lineHeight: 1.5,
    },
    list: {
        listStyle: 'none',
        padding: 0,
        margin: '0 0 30px 0',
        width: '100%',
        textAlign: 'center',
        flexGrow: 1,
    },
    listItem: {
        fontSize: '14px',
        color: '#555',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    actionButton: {
        width: '100%',
        height: '50px',
        backgroundColor: '#fff !important',
        color: '#ff6468 !important',
        border: '2px solid #ff6468 !important',
        borderRadius: '25px !important',
        fontSize: '16px !important',
        fontWeight: 'bold !important',
        textTransform: 'none !important',
        '&:hover': {
            backgroundColor: '#ff6468 !important',
            color: '#fff !important',
        },
    },
    contactButton: {
        backgroundColor: '#ff6468 !important',
        color: '#fff !important',
        '&:hover': {
            backgroundColor: '#e05559 !important',
        },
    },
    extraInfo: {
        fontSize: '14px !important',
        fontWeight: 'bold !important',
        color: '#000',
        marginTop: '0px',
        textAlign: 'center',
        marginBottom: '15px !important',
        width: '100%',
    },
    featuresList: {
        margin: '8px 0 30px 0',
        width: '100%',
        flexGrow: 1,
    },
    featureSectionHeader: {
        fontWeight: 'bold',
        fontSize: '13px',
        color: '#333',
        marginTop: '12px',
        marginBottom: '4px',
    },
    featureItem: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '6px',
        fontSize: '13px',
        color: '#555',
        marginBottom: '6px',
    },
}));

export default useStyles;
